export default __webpack_public_path__ + "icons/favicon-16x16-601250e750a78c15dc13887f2de096ac.png";